














import { OrgRole } from '@/models';
import { OrgUser } from '@/models/orgStructure';
import Vue, { PropType } from 'vue';
import { orgRoleOf } from '@/orgRole';
import { orgRoleColors } from '../utils/unrulrColors';
export default Vue.extend({
  props: {
    user: Object as PropType<OrgUser>
  },

  computed: {
    // Never rendered for orphans, so the fallback only narrows the type.
    role(): OrgRole {
      return orgRoleOf(this.user) ?? OrgRole.MEMBER;
    },

    borderColorClasses(): string[] {
      switch (this.role) {
        case OrgRole.ADMIN:
          return orgRoleColors.admin;
        case OrgRole.ORGANIZER:
          return orgRoleColors.organizer;
        case OrgRole.MEMBER:
          return orgRoleColors.member;
      }

      return [];
    },

    borderColor(): string {
      return this.borderColorClasses.join(' ');
    }
  }
});
